import {
    DEFAULT_PAGE_SIZE,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ODER_BY_TYPE
} from '@app/constants/Common';
import CddNeedFuEditModal from "@pages/candidate/cddneedfu/CddNeedFuEditModal";
import { CddEmpProcessOptions } from "@pages/dvtjcuv/common/Constant";
import React, { useEffect, useState } from 'react';

const TableColumns = [
    {
        key: 'candidate_id',
        label: 'Cdd ID (nội bộ)',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'dvtjcuv_client_id',
        label: 'Cdd ID (DVTJCUV)',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'industry_function',
        label: 'Phân loại',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'level',
        label: 'Level',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    // {
    //     key: 'industry_segment1',
    //     label: 'Industry - PK1',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: true,
    //     autoAdd: true,
    //     searchable: false
    // },
    // {
    //     key: 'industry_segment2',
    //     label: 'Industry - PK2',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: true,
    //     autoAdd: true,
    //     searchable: false
    // },
    // {
    //     key: 'function',
    //     label: 'Function',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    // {
    //     key: 'function_segment1',
    //     label: 'Function - PK1',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    // {
    //     key: 'function_segment1',
    //     label: 'Function - PK2',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    // {
    //     key: 'local_province_email',
    //     label: 'Loca tỉnh (email)',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: true,
    //     autoAdd: true,
    //     searchable: false
    // },
    // {
    //     key: 'local_oversea_email',
    //     label: 'Local oversea email',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: true,
    //     autoAdd: true,
    //     searchable: false
    // },
    {
        key: 'workable_location',
        label: 'Workable Location',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'check_ref',
        label: 'Check Ref',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'local_nationality',
        label: 'Quốc tịch',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'expect_salary',
        label: 'Lương',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'age1',
        label: 'Tuổi',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'fee_to_employer',
        label: 'Fee',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'sent_time',
        label: 'Sent time',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'note',
        label: 'note',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },

];

const getIndustryFunctionString = (candidate) => {
    return [candidate.industry,
         candidate.industry_segment1,
          candidate.industry_segment2,
           candidate.function, candidate.function_segment1,
            candidate.function_segment2].filter(Boolean).join(' ; ');
}

const getWorkableLocation = (candidate) => {
    return [
         candidate.local_province_email,
          candidate.local_oversea_email]
        .filter(Boolean)
        .join(' ; ');
}

const CddNeedFuListTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(0);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [selectItem, setSelectItem] = useState({});
    const [sortColumnInfo, setSortColumnInfo] = useState({});
    const [candidateList, setCandidateList] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);

    const {
        candidates,
        totalCount,
        onSearchCandidates,
    } = props

    useEffect(() => {
        const canList = [...candidates]
        // sort canList by sent_time desc
        canList.sort((a, b) => {
            return new Date(b.sent_time) - new Date(a.sent_time)
        })
        setCandidateList(canList)
    }, [candidates])

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const onShowEditModal = (item) => {
        setSelectItem({...item})
        setShowEditModal(true)
    }

    const onSort = async (columnKey) => {
        let sortColumns = {...sortColumnInfo}
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        setSortColumnInfo(sortColumns)
        // sort candidateList by columnKey
        const sortedList = [...candidateList]
        sortedList.sort((a, b) => {
            // check Order type asc or desc and string or number or work_location
            if (sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
                if (columnKey === 'workable_location') {
                    return getWorkableLocation(a).localeCompare(getWorkableLocation(b))
                }
                
                if (typeof a[columnKey] === 'string' || !a[columnKey]) {
                    return (a[columnKey] || "0").localeCompare(b[columnKey] || "0")
                }

                // check if columnKey is industry_function
                if (columnKey === 'industry_function') {
                    return getIndustryFunctionString(a).localeCompare(getIndustryFunctionString(b))
                }
                return a[columnKey] - b[columnKey]
            }
            
            if (columnKey === 'workable_location') {
                return getWorkableLocation(b).localeCompare(getWorkableLocation(a))
            }

            // check if columnKey is industry_function
            if (columnKey === 'industry_function') {
                return getIndustryFunctionString(b).localeCompare(getIndustryFunctionString(a))
            }
            
            if (typeof b[columnKey] === 'string' || !b[columnKey]) {
                return (b[columnKey] || "0").localeCompare(a[columnKey] || "0")
            }

            return b[columnKey] - a[columnKey]
        })

        setCandidateList(sortedList)
    }

    const onClickSortColumn = (column) => {
        onSort(column.key)
    }

    const classSortingType = (column) => {
        const sortType = sortColumnInfo[column.key]
        if (sortType) {
            return sortType === ODER_BY_TYPE.DESC ? 'sorting_desc' : 'sorting_asc'
        }

        return ""
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Danh sách Cdd ({totalCount || 0})</h3>
                {totalCount > 0 &&
                <h3 className='card-title text-bold ml-3'>Page: {currentPage}/{numberPages}</h3>
                }
                <br/>
                {/*{showBtnSelect &&*/}
                {/*<h4 className='card-title'>Selected: {selectedCount}</h4>*/}
                {/*}*/}
                <div className='card-tools'>
                    {/*{numberPages > 1 &&*/}
                    {/*<ul className='pagination pagination-sm float-right mt-2 ml-5'>*/}
                    {/*    <li className='page-item'>*/}
                    {/*        <button className='page-link' type={'button'}*/}
                    {/*                onClick={() => backPage()}>&laquo;</button>*/}
                    {/*    </li>*/}

                    {/*    <li className='page-item'>*/}
                    {/*        <button className='page-link' type={'button'}*/}
                    {/*                onClick={() => nextPage()}>&raquo;</button>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                    {/*}*/}
                    
                </div>
            </div>
            <div className='card-body table-responsive p-0'>
                <table
                    className='table table-hover dataTable table-bordered text-nowrap text-center'
                    // style={{maxHeight: '80vh', overflow: 'scroll'}}
                >
                    <thead>
                    <tr>
                        {/*{showBtnSelect &&*/}
                        {/*    <th className={"pl-0"}>*/}
                        {/*        <input type="checkbox"*/}
                        {/*               style={{width: 20, height: 20}}*/}
                        {/*               checked={isSelectedAll}*/}
                        {/*               onChange={event => onSelectedAll(event)}*/}
                        {/*        />*/}
                        {/*    </th>*/}
                        {/*}*/}
                        <th>No.</th>
                        {TableColumns.map(item => {
                            return <th
                                className={`sorting ${classSortingType(item)}`}
                                onClick={() => onClickSortColumn(item)}
                                key={`CddNeedFuListTableColumns_th_${item.key}`}>{item.label}</th>
                        })}
                        <th>Hành động</th>
                    </tr>
                    </thead>
                    <tbody>
                    {candidateList && candidateList.length > 0 && candidateList.map((candidate, index) => (
                        <tr key={`candidate_${index}`}>
                            {/*{showBtnSelect &&*/}
                            {/*<td style={{paddingLeft: '.75rem'}}>*/}
                            {/*    <input type="checkbox"*/}
                            {/*           style={{width: 20, height: 20}}*/}
                            {/*        // value={!!searchConditions.only_user_input}*/}
                            {/*           checked={candidate.isSelected}*/}
                            {/*           onChange={() => onSelectedItem(index)}*/}
                            {/*    />*/}
                            {/*</td>*/}
                            {/*}*/}
                            <td>{(currentPage - 1) * DEFAULT_PAGE_SIZE + index + 1}</td>
                            {/*<td>*/}
                            {/*    <a href="javascript:void(0)" onClick={() => openCandidateDetail(candidate.id)}>*/}
                            {/*        {candidate.general.id}*/}
                            {/*    </a>*/}
                            {/*</td>*/}
                            {TableColumns.map(field => {
                                if (field.key === 'industry_function') {
                                    return <td className={`${field.classNames} breakline`}
                                               key={`piplentablelist_row_${index}_column_${field.key}`}>
                                        {getIndustryFunctionString(candidate)}
                                    </td>
                                }
                                if (field.key === 'workable_location') {
                                    return <td className={`${field.classNames}`} style={{maxWidth: 200}}
                                               key={`piplentablelist_row_${index}_column_${field.key}`}>
                                        {getWorkableLocation(candidate)}
                                    </td>
                                }

                                
                                if (field.displayType === 'link') {
                                    return <td className={`${field.classNames} text-truncate`} style={{maxWidth: 200}}
                                               key={`piplentablelist_row_${index}_column_${field.key}`}>
                                        <a href={`${field.link}${field.key === 'dvtjcuv_client_id'
                                             ? candidate.candidate_id : candidate[field.key]}`} target="_blank"
                                           rel="noreferrer"
                                           className={'text-primary font-weight-bold'}>{candidate[field.key]}</a>
                                    </td>
                                }

                                return <td className={`${field.classNames} text-truncate`} style={{maxWidth: 200}}
                                           key={`piplentablelist_row_${index}_column_${field.key}`}>
                                    {candidate[field.key]}
                                </td>
                            })}
                            <td>
                                <button
                                    className={'btn btn-default'} type={'button'}
                                    onClick={() => {onShowEditModal(candidate)}}
                                >
                                    Edit
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {showEditModal &&
            <CddNeedFuEditModal
                isShow={showEditModal}
                data={selectItem}
                onClose={(reload) => {
                    setShowEditModal(false)
                    if (reload) {
                        onSearchCandidates(reload);
                    }
                }}
                />
            }
        </div>
    );
};

export default CddNeedFuListTable;
